import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { ProductPriceFormatterComponent } from '../product-price-formatter';

@Component({
  selector: 'ui-product-prices-default',
  templateUrl: './product-prices-default.component.html',
  styleUrls: ['./product-prices-default.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ProductPriceFormatterComponent,
  ],
})
export class ProductPricesDefaultComponent {
  public price: InputSignal<number> = input.required();
  public showThousandthsPlace: InputSignal<boolean> = input(false);
}
